export const buildDowngradeSurveyUrl = (
  fromPlanName: string,
  toPlanName: string,
  interval: string
) => {
  const fromPlanNameParam = encodeURIComponent(fromPlanName.toLowerCase());
  const toPlanNameParam = encodeURIComponent(toPlanName.toLowerCase());
  return `/app/billing/plans/downgrade-survey/${fromPlanNameParam}/${toPlanNameParam}/${interval.toLowerCase()}`;
};
